import React from 'react';
import { Text } from '../Text/Text';
import { MarginProps } from '../../../theme/styledProps';
import { Tooltip } from '../Tooltip/Tooltip';
import { Icon } from '../Icon/Icon';

const colorMap = {
  success: 'success.700',
  error: 'error.700',
};

type LabelVariant = 'success' | 'warning' | 'error';

export interface LabelProps extends MarginProps {
  id?: string;
  variant?: LabelVariant;
  htmlFor?: string;
  tooltip?: React.ReactNode;
  className?: string;
}

// The `opl-label` class is stamped on every OPL design-system label so that
// legacy global rules like `.adv-form label { ... }` in
// `sass/base/form/_input.scss` can opt out via `:not(:where(.opl-label))`.
export const Label: React.FC<LabelProps> = ({
  htmlFor,
  variant,
  children,
  tooltip,
  className,
  ...rest
}) => {
  return (
    <>
      <Text
        as="label"
        variant="formLabel"
        htmlFor={htmlFor}
        color={(variant && colorMap[variant]) || 'neutral.600'}
        className={['opl-label', className].filter(Boolean).join(' ')}
        {...rest}
      >
        {children}
      </Text>

      {tooltip && (
        <Tooltip content={tooltip} placement="right-end">
          <Icon className="far fa-info-circle" color="neutral.500" fontSize="small" ml="4" />
        </Tooltip>
      )}
    </>
  );
};
